<template>
  <div class="notifications-root">
    <div class="notifications" @click="toggleNotifications" ref="notificationInfo" :class="{'open-notifs': showNotifications}">
      <img src='@/assets/images/bell_ico.png' />
      <div class="notifications-marker" v-show="notificationsNumber > 0">{{ notificationsNumber }}</div>
      <img class="notifications-arrow" src="@/assets/images/arrow_down.png" />
    </div>

    <div class="notifications-menu" v-show="showNotifications" ref="notificationArea">
      <div class="notifications-fixed">
        <p>{{ $lang.messages.notifHeadline }}</p>
        <button @click="markAllRead">{{ $lang.messages.markAllRead }}</button>
      </div>
      <div
        ref="notificationContainer"
        class="notifications-container"
        @scroll="scrollNotifications"
      >
        <div class="skeleton-screen" v-show="loading" v-for="(i) of skeletonArray">
          <div></div>
        </div>
        <div
          v-for="(content) in list"
          :key="content.referenceGuid"
          class="notifications-list"
          v-show="!loading"
        >
          <router-link
            :to="{ name: computedRoute(content.referenceType.toLowerCase()),  params: { id: content.referenceGuid } }"
            class="item"
          >
            <div>
              {{ content.message }}
            </div>
            <p>{{ fuzzyFormatDate(content.created) }}</p>
            <img src="@/assets/images/arrow_right.png" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GET_NOTIFICATIONS_ALL,
    MARK_NOTIFICATIONS_READ_ALL
  } from "@/store/action.types"
  import {
    WS_NOTIFICATIONS_COUNT_SUBSCRIBE,
    WS_NOTIFICATIONS_COUNT_SEND
  } from '@/constants/ApiConstants'

  import { mapActions, mapGetters } from "vuex"
  import { dateFormat } from '@/mixins/dateFormat';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
      name: "Notifications",
      mixins: [
        dateFormat
      ],
      props: {
        handleCloseAsideOnNotifs: {
          type: Function
        }
      },
      data() {
        return {
          notificationsNumber: 0,
          showNotifications: false,
          list: [],
          scrollPage: 0,
          initialNotificationContainerHeight: 0,
          loading: false,
          skeletonArray: [{}, {}],
          intervalCount: null
        }
      },
    computed: {
      ...mapGetters([
        "paymentPreferenceCompleted",
        "parentingSchedulePreferenceCompleted",
        'currentStep',
        "isAppLocked",
        "coparentGuid"
      ]),
    },
    mounted() {
      this.onClickOutside();
      this.getNotificationsCount();
    },
    beforeDestroy() {
      window.clearInterval(this.intervalCount)
    },
    methods: {
      ...mapActions({
        getNotificationsAllAction: GET_NOTIFICATIONS_ALL,
        markNotificationsReadAllAction: MARK_NOTIFICATIONS_READ_ALL
      }),
      toggleNotifications() {
        if (this.list.length === 0) {
            this.loading = true;
        }
        this.showNotifications = !this.showNotifications;
        if(this.showNotifications) {
            if (this.scrollPage > 0) {
                this.scrollPage = 0;
            }
            this.getNotificationsAll();
        }
        if (window.innerWidth <= 1024) {
            this.handleCloseAsideOnNotifs()
        }
      },
      getNotificationsAll() {
        this.getNotificationsAllAction('page=' + this.scrollPage + '&size=10')
        .then(response => {
          this.loading = false;
          this.list = response.data.data.content;
        }).catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        })
      },
      /**
       * @description Get notifications count using Notifications websocket channel
       */
      getNotificationsCount() {
        if (localStorage.getItem('user') !== null && this.paymentPreferenceCompleted && this.parentingSchedulePreferenceCompleted) {
          this.$root.$on('fp-app-websocket-connected', () => {
            this.subscribeWSNotificationsChannel()
          })
        }
      },
      /**
       * @description Subscribe to websocket Notifications channel
       */
      subscribeWSNotificationsChannel() {
        if (this.$parent.fpAppStompClient && this.$parent.fpAppStompClient.connected) {
          this.$parent.fpAppStompClient
            .send(WS_NOTIFICATIONS_COUNT_SEND.replace(':coparentGuid', this.coparentGuid))

          this.$parent.fpAppStompClient
            .subscribe(WS_NOTIFICATIONS_COUNT_SUBSCRIBE.replace(':coparentGuid', this.coparentGuid), tick => {
              this.notificationsNumber = parseInt(tick.body)
            })
        }
      },
      markAllRead() {
        this.markNotificationsReadAllAction()
        .then(() => {
          this.showNotifications = false;
          this.notificationsNumber = 0;
        }).catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        })
      },
      scrollNotifications(e) {
        let notificationContainer = this.$refs.notificationContainer;

        // scroll "DOWN" Api call
        if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
          if (notificationContainer) {
            this.initialNotificationContainerHeight = notificationContainer.offsetHeight;
          }
          this.scrollPage++;
          this.getNotificationsAllAction('page=' + this.scrollPage + '&size=10')
          .then(response => {
            let responseData = response.data.data.content;
            if (responseData.length > 0) {
              this.list.push(...responseData);
            }
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          })
        }
      },
      onClickOutside() {
        document.addEventListener('click', (e) => {
          let clickedElement = e.target;
          let notificationInfo = this.$refs.notificationInfo;

          if (notificationInfo !== clickedElement && clickedElement.parentNode !== notificationInfo) {
            this.showNotifications = false;
            this.list = [];
            if (this.$refs.notificationArea) {
              this.$refs.notificationArea.scrollTo(0, 0);
            }
          }
        });
      },
      fuzzyFormatDate(date) {
        date = new Date(date);
        const now = Date.now();

        const delta = Math.round((now - date) / 1000);

        const minute = 60;
        const hour = minute * 60;
        const day = hour * 24;
        const week = day * 7;

        if (delta < 30) {
          return 'Just now...'
        }
        else if (delta < minute) {
          return delta + ' seconds ago.'
        }
        else if (delta < 2 * minute) {
          return 'A minute ago.'
        }
        else if (delta < hour) {
          return Math.floor(delta / minute) + ' minutes ago.'
        }
        else if (Math.floor(delta / hour) === 1) {
          return '1 hour ago.'
        }
        else if (delta < day) {
          return Math.floor(delta / hour) + ' hours ago.'
        }
        else if (delta < day * 2) {
          return 'Yesterday.'
        }
        else if (delta < week) {
          return Math.floor(delta / week) + ' days ago.'
        }
        else if (delta < week * 2) {
          return 'A week ago.'
        }
        else {
          return this.dateFormat(date);
        }
      },
      computedRoute(type) {
        return (
          type === 'spousal maintenance' ? 'ExpenseDetailsSpousalMaintenance' :
          type === 'child maintenance' ? 'ExpenseDetailsChildMaintenance' :
          type === 'shared expenses' ? 'ExpenseDetailsSharedExpenses' :
          type === 'invitation accepted' || type === 'coparent invited' || type === 'child added'? 'FamilyProfile' : ''
        );
      },
    }
  }
</script>
